import { AlmanacFile } from 'types'
import { FunctionComponent } from 'react'
import { GenerationType } from 'components/BlazeCommandLine/api/createDocGenerationRequest'
import { ChannelType } from 'components/CampaignCreationModal/Types'

export const MOST_POPULAR_CHANNELS = [
  GenerationType.Campaign,
  GenerationType.Brainstorm,
  ChannelType.BlogPost,
  ChannelType.InstagramPosts,
  ChannelType.FacebookPost,
  ChannelType.LinkedInPosts,
  ChannelType.TikTokScript,
  ChannelType.Newsletter,
]
export interface SectionProps {
  /** Initial values to pass to the wizards */
  initialValues?: any
  onSuccess?: (data: { almanac_file: AlmanacFile }) => void
  search?: string
  onClick?: () => void
}

export type CategoryItem = {
  icon: React.ReactNode
  title: string
  wizard: FunctionComponent<any>
  extraProps?: object | undefined
  tags: string[]
  description?: string | undefined
  categoryTitle: string
}
